module.exports = __webpack_public_path__ + "img/moskit-icon.50e8892d.svg";